var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-list-group',[_c('b-list-group-item',{staticClass:"d-flex st-sidebartitle"},[_vm._v(" "+_vm._s(_vm.name)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }